import type { PricingContextModule } from 'app/features/FragmentRoot/contexts/pricing/interface'

export const getPricingContextFromBrowser = (): PricingContextModule.PcxtV3 | undefined => {
  return window.document.pcxtV3 as PricingContextModule.PcxtV3
}
